import React from 'react';
import './WhyUs.css';

import { whyChooseUs } from '../../../constants';
import { Heading } from '../../../components';



const WhyUs = () => {
    return (
        <section className="why-us">

            {/* Section Heading */}
            <Heading title={whyChooseUs.heading} subTitle={whyChooseUs.sub} linear />

            {/* Why Choose Us Description */}
            <p>{whyChooseUs.content}</p>

            {/* Key Benefits */}
            <div className="box-container">
                {whyChooseUs.points.map(point => (
                    <div className='whyus-item' key={point.id}>
                        <span>{point.title}</span> {/* Benefit Title */}
                        <div className='icon'>{point.icon}</div> {/* Benefit Icon */}
                    </div>
                ))}
            </div>

        </section>
    );
};

export default WhyUs;